export default "__VITE_ASSET__BoFHY9Kg__"